<template>
  <div class="gs-app gm-contact-import">
    <!-- Loader -->
    <portal to="loaderTarget">
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>
    </portal>

    <div class="gm-contact-import__shell min-h-screen h-auto bg-secondary-darker pb-6 -my-3 -mx-5">
      <div class="relative w-full flex flex-col justify-start">
        <div class="gm-contact-import__header flex flex-row w-full text-secondary-invert px-4">
          <gd-tabs
            :tabs="tabs"
            :currentTab="model.currentTab"
            :disableNotCompleted="true"
            :wrapper-class="'pt-4 px-0 gs-default-tabs'"
            :tab-class="mainTabClass"
            :tab-active-class="'border-primary border-b-2 text-primary gs-default-tabs-item-active'"
            :line-class="'gs-default-tabs-active-line'"
            @onClick="handleTabChange"
            :key="this.$t('frontend_groovemail_contact_tabs_upload')"
          />
          <div class="gm-contact-import__header-actions flex flex-row ml-8">
            <gd-button
              size="auto"
              @click="moveBackOnWizard"
              :style="{
                visibility: model.currentTab != 'step1' ? 'visible' : 'hidden',
              }"
            >
              {{ $t('frontend_groovemail_contacts_create_back') }}
            </gd-button>
            <gd-button
              size="auto"
              @click="moveNextOnWizard"
              v-if="model.currentTab != 'step6'"
              >{{ $t('frontend_products_create_save_next') }}</gd-button
            >
            <gd-button
              variant="primary"
              size="auto"
              class="mr-4 p-4 mt-3"
              v-else
              @click="saveAndExitWizard"
              >{{ $t('frontend_products_create_save_exit') }}</gd-button
            >
          </div>
        </div>
      </div>

      <div class="gm-contact-import__body relative w-full h-full flex flex-col justify-start mt-8 px-4">
        <div class="text-secondary-invert w-full">
          <div v-if="model.currentTab === 'step1'">
            <step1
              ref="step1"
              :model="model"
              @updateModel="model = $event"
              @on-validate="stepValidationSuccessful('step1', $event)"
            ></step1>
          </div>
          <div v-if="model.currentTab === 'step2'">
            <step2
              ref="step2"
              :model="model"
              @updateModel="model = $event"
              @on-validate="stepValidationSuccessful('step2', $event)"
            ></step2>
          </div>
          <div v-if="model.currentTab === 'step3'">
            <step3
              ref="step3"
              :model="model"
              @updateModel="model = $event"
              @on-validate="stepValidationSuccessful('step3', $event)"
            ></step3>
          </div>
          <div v-if="model.currentTab === 'step4'">
            <step4
              ref="step4"
              :model="model"
              @updateModel="model = $event"
              @on-validate="stepValidationSuccessful('step4', $event)"
            ></step4>
          </div>
          <div v-if="model.currentTab === 'step5'">
            <step5
              ref="step5"
              :model="model"
              @updateModel="model = $event"
              @on-validate="stepValidationSuccessful('step5', $event)"
            ></step5>
          </div>
          <div v-if="model.currentTab === 'step6'">
            <step6
              :model="model"
              @updateModel="model = $event"
              @on-validate="stepValidationSuccessful('step6', $event)"
            ></step6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Maillead from '@/models/Maillead';
import Mailsegment from '@/models/Mailsegment';
import Maillist from '@/models/Maillist';
import Campaign from '@/models/Campaign';
import Contact from '@/models/Contact';
import Import from '@/models/Import';
import Swal from 'sweetalert2';
import router from '@/router';
import themeConfig from '@/theme/themeConfig.js';
import store from '@/state';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import Paginate from 'vuejs-paginate';

// importing steps
import step1 from './step1';
import step2 from './step2';
import step3 from './step3';
import step4 from './step4';
import step5 from './step5';
import step6 from './step6';

const axios = require('axios');


export default {
  middleware: 'auth',
  metaInfo() {
    return { title: 'Import Contacts' };
  },
  data() {
    return {
      tabs: [
        {
          title: `<span class="text-sm  font-semibold"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
            ${this.$t('frontend_groovemail_contact_tabs_upload')}
            <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>`,
          value: 'step1',
        },
        {
          title: `<span class="text-sm  font-semibold"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
            ${this.$t(
              'frontend_groovemail_contact_tabs_match_fields'
            )} <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>`,
          value: 'step2',
        },
        {
          title: `<span class="text-sm  font-semibold"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
            ${this.$t(
              'frontend_groovemail_contact_tabs_filter_record'
            )} <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>`,
          value: 'step3',
        },
        {
          title: `<span class="text-sm  font-semibold"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
             ${this.$t(
               'frontend_groovemail_contact_tabs_automations'
             )} <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>`,
          value: 'step4',
        },
        {
          title: `<span class="text-sm  font-semibold"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
             ${this.$t(
               'frontend_groovemail_contact_tabs_questionnaire'
             )} <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>`,
          value: 'step5',
        },
        {
          title: `<span class="text-sm  font-semibold"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
            ${this.$t(
              'frontend_groovemail_contact_tabs_import_finish'
            )} <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>`,
          value: 'step6',
        },
      ],

      postValidationTab: 'step2',
      currentTab: 'step1',
      assigned_to: null,
      mainWizardIndex: 0,
      fullPageLoader: true,
      isLoading: false,
      model: {
        currentTab: 'step1',
        tag: '',
        category: '',
        tagname: '',
        list: '',
        listname: '',
        name: '',
        description: '',
        tgname: '',
        categoryname: '',
        tgdescription: '',
        tgcategory: [],
        is_overwrite: true,
        has_headers: true,
        created_contacts: [],
        importid: '',
        matchfields: [],
        totalfields: 0,
        upload_contacts_data: [],
        upload_tab: 'import',
        uploaded: null,
        failed: null,
        duplicated: null,
        blocked: null,
        alreadyexisitng: null,
        imported: null,
        selectedlistids: [],
        selectedtagids: [],
        selectedtags: [],
        selectedlists: [],
      },
      formData: new FormData(),
      loaderColor: themeConfig.appPrimaryColor,
      contact_tabs: [
        {
          title:
            '<span class="text-sm  font-semibold"><i class="fa fa-upload" aria-hidden="true"></i>&nbsp;Import <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>',
          value: 'step1',
        },
        {
          title:
            '<span class="text-sm font-semibold"><i class="fa fa-plus" aria-hidden="true"></i>&nbsp;Manualy Add<i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>',
          value: 'step2',
        },
      ],
    };
  },
  validations: {
    model: {
      name: { required, minLength: minLength(3), maxLength: maxLength(50) },
      description: { required },
    },
  },
  components: {
    Paginate,
    vueDropzone: vue2Dropzone,
    step1,
    step2,
    step3,
    step4,
    step5,
    step6,
  },
  methods: {
    moveNextOnWizard() {
      let currentlySelectedTabIndex = this.tabs
        .map((item) => item.value)
        .indexOf(this.model.currentTab);
      let nextTab = this.tabs[currentlySelectedTabIndex + 1].value;
      this.postValidationTab = nextTab;
      var refToValidate = this.$refs[this.model.currentTab];
      return refToValidate.validate();
      //this.currentTab = nextTab;
    },

    moveBackOnWizard() {
      let currentlySelectedTabIndex = this.tabs
        .map((item) => item.value)
        .indexOf(this.model.currentTab);
      let nextTab = this.tabs[currentlySelectedTabIndex - 1].value;
      this.postValidationTab = nextTab;

      this.model.currentTab = nextTab;
    },

    async saveAndExitWizard() {
      this.showLoader();
      this.$router.push({ name: 'Lists' });
      this.hideLoader();
      //this.timer = setInterval(this.$router.push({name: 'Broadcasts'}), 2000)
    },

    validateStep(name) {
      var refToValidate = this.$refs[name];
      return refToValidate.validate();
    },

    async stepValidationSuccessful(name, isValid) {
      if (isValid) {
        if (name === 'step1' && this.model.upload_tab === 'manually') {
          this.uploadcontacts();
        }
        if (name === 'step2') {
          this.saveMappedFields();
        }
        if (name === 'step4') {
          this.saveautomation();
        }
        this.model.currentTab = this.postValidationTab;
      }
    },

    async saveautomation() {
      this.showLoader();
      this.maillead = new Maillead({});
      this.maillead.importid = this.model.importid;
      this.maillead.tags = this.model.selectedtagids;
      this.maillead.lists = this.model.selectedlistids;
      (this.maillead.csv = this.model.matchfields),
        (this.maillead.listid = this.$route.params.id),
        (this.maillead.is_overwrite = this.model.is_overwrite),
        (this.maillead.is_manually = '0');
      await this.maillead.save().then((response) => {
        this.hideLoader();
      });
    },

    async uploadcontacts() {
      this.showLoader();
      let contacts = new Contact({
        csv: this.model.upload_contacts_data,
        is_processing: 1,
        type: 'manually',
      });
      await contacts.save().then((response) => {
        this.model.created_contacts = response.records;
        this.model.totalfields = response.records[0].length;
        this.model.importid = response.importid;
        this.hideLoader();
      });
      this.model.matchfields = [];
    },

    async saveMappedFields() {
      this.showLoader();
      let imports = new Import({
        is_save: 1,
        importid: this.model.importid,
        csv: this.model.matchfields,
        listid: this.$route.params.id,
      });
      await imports.save().then((response) => {
        this.model.uploaded = response.uploaded;
        this.model.failed = response.failed;
        this.model.duplicated = response.duplicated;
        this.model.blocked = response.blocked;
        this.model.alreadyexisitng = response.alreadyexisitng;
        this.model.imported = response.imported;
        this.hideLoader();
      });
    },

    handleTabChange(newTab) {
      //this.currentTab = newTab;
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },

  computed: {
    mainTabClass() {
      if (this.model.currentTab === 'step1') {
        return 'pb-4 gs-default-tabs-item';
      } else {
        return 'pb-4 gs-default-tabs-item';
      }
    },
  },
};
</script>

<style>
@import url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');
</style>

<style scoped>
.gm-contact-import {
  min-height: 100%;
  padding: 28px;
  color: var(--gs-foreground);
  background: var(--gs-background);
}

.gm-contact-import__shell {
  max-width: 1280px;
  margin-right: auto;
  margin-left: auto;
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gm-contact-import__header,
.gm-contact-import__body {
  min-width: 0;
}

@media (max-width: 640px) {
  .gm-contact-import {
    padding: 16px;
  }

  .gm-contact-import__shell {
    margin-right: 0;
    margin-left: 0;
    border-radius: var(--gs-radius-md);
  }

  .gm-contact-import__header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .gm-contact-import__header-actions {
    flex-wrap: wrap;
    gap: 8px;
    margin-left: 0;
  }
}
</style>

<style>
.gs-default-tabs-item:focus {
  outline: none !important;
  outline-style: none !important;
}
.single-row {
  display: flex;
  padding: 0 15px;
  align-items: center;
  margin: 0 0 30px;
}
.icon {
  margin-right: 15px;
  font-size: 30px;
}
.counttotal {
  color: #000;
  font-size: 24px;
  margin-bottom: 5px;
  line-height: 1;
}
.counttitle {
  text-transform: uppercase;
  font-size: 12px;
  line-height: 1;
  color: #aaa;
}
.left_content {
  width: 30%;
  border-right: 1px solid #ddd;
  padding: 20px 15px;
  float: left;
}
.right_content {
  width: 70%;
  float: left;
  text-align: center;
}
.right_content .icon span {
  font-size: 200px;
  color: #95d595;
}
.improttotal {
  color: #05cff0;
  font-weight: bold;
}

.radio-custom {
  opacity: 0;
  position: absolute;
}

.radio-custom,
.radio-custom-label {
  display: inline-block;
  vertical-align: middle;
  margin: 5px;
  cursor: pointer;
}

.radio-custom-label {
  position: relative;
}

.radio-custom + .radio-custom-label:before {
  content: '';
  background: #fff;
  border: 2px solid #ddd;
  display: inline-block;
  vertical-align: middle;
  width: 32px;
  height: 32px;
  padding: 2px;
  margin-right: 10px;
  text-align: center;
}

.radio-custom + .radio-custom-label:before {
  border-radius: 50%;
}

.radio-custom:checked + .radio-custom-label::before {
  content: '\f00c';
  font-family: 'FontAwesome';
  color: #fff;
  background: #282b49;
  border-color: #282b49;
}

.radio-custom:focus + .radio-custom-label {
  outline: 1px solid #ddd; /* focus style */
}
.savebtn {
  background: #59aa3c;
  color: #fff;
  border: #59aa3c;
  padding: 5px 20px;
  border-radius: 10px;
}
.optionsection {
  width: 50%;
}
#assigntag {
  display: none;
}
.changebtn {
  background: #e7e7e7;
  color: #000;
  border: #e7e7e7;
  padding: 5px 20px;
  border-radius: 10px;
}

.offbtn {
  padding: 5px 20px;
  background-color: #7e7e7e;
  border-radius: 5px;
  border: 1px solid #7e7e7e;
  color: #fff;
}
.notsubscribe {
  padding: 5px 20px;
  background-color: #eeeeee;
  border-radius: 5px;
  border: 1px solid #eee;
}
.autosec {
  box-shadow: 0 0 5px #ccc;
  margin: 20px;
}

.select_wrap {
  width: 100%;
}

.checkdiv {
  width: 30%;
  float: left;
  text-align: right;
  color: #fff;
  font-size: 70px;
}
.msgheading {
  font-size: 35px;
  color: #fff;
  text-transform: uppercase;
  font-weight: bold;
}
.msgdesc {
  color: #fff;
  font-size: 21px;
}
.importmsg {
  width: 65%;
  float: left;
  text-align: left;
}
.leftcol {
  width: 65%;
  font-size: 20px;
  font-weight: bold;
}
.rightcol {
  width: 30%;
  text-align: right;
}
.blue-lg-btn {
  border: 1px solid #00abff;
  padding: 5px 20px;
  border-radius: 5px;
  background-color: #00abff;
  color: #fff;
  font-weight: bold;
  width: 185px;
  text-align: center;
}
.disabled {
  cursor: not-allowed;
}
</style>
